import { render, staticRenderFns } from "./mo-select-wrapper.html?vue&type=template&id=04db47f1&external"
import script from "./mo-select-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-select-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04db47f1')) {
      api.createRecord('04db47f1', component.options)
    } else {
      api.reload('04db47f1', component.options)
    }
    module.hot.accept("./mo-select-wrapper.html?vue&type=template&id=04db47f1&external", function () {
      api.rerender('04db47f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-select-wrapper/mo-select-wrapper.vue"
export default component.exports